import * as React from 'react';
import Radio from '@mui/material/Radio';
import RadioGroup from '@mui/material/RadioGroup';
import FormControlLabel from '@mui/material/FormControlLabel';

export default function RadioButtonsGroup({ formData, onChange, options, radioFlex, fieldId }) {

    return (
        <RadioGroup
            aria-labelledby="demo-radio-buttons-group-label"
            defaultValue="female"
            name="radio-buttons-group"
            row={radioFlex ? true : false}
        >
            {
                options.map(({ value, label }) => {
                    return (
                        <FormControlLabel onChange={(val) => {
                            onChange(fieldId, val.target.value)
                        }} value={value} control={<Radio checked={value == formData?.[fieldId]} />} label={<span style={{ fontWeight: "normal" }} >{label}</span>} />
                    )
                })
            }
        </RadioGroup>
    );
}
